var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 274.84 268.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;}.d,.e,.f,.g,.h,.i{stroke-linecap:round;stroke-linejoin:round;stroke-width:7px;}.d,.h{stroke:#99c5ff;}.e{fill:#5da8f6;}.e,.g,.i{stroke:#386aff;}.f{stroke:#5da8f6;}.f,.h,.i{fill:#abcfff;}.g{fill:#99c5ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "130.11 253.78 3.5 118.24 87.91 118.24 130.11 253.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "256.72 118.24 130.11 253.78 172.31 118.24 256.72 118.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "256.71 118.24 3.5 118.24 45.71 59.86 45.71 59.85 214.51 59.85 256.71 118.24"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "87.91 118.24 3.5 118.24 45.7 59.85 45.71 59.86 87.91 118.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "172.31 118.24 87.91 118.24 130.11 59.85 172.31 118.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "256.72 118.24 172.31 118.24 214.51 59.85 256.72 118.24"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "172.31 118.24 130.11 253.78 87.91 118.24 172.31 118.24"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 208.99,
    y1: 11.21,
    x2: 208.99,
    y2: 36.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 221.8,
    y1: 24.02,
    x2: 196.19,
    y2: 24.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 249.14,
    y1: 49.76,
    x2: 249.14,
    y2: 75.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 261.95,
    y1: 62.56,
    x2: 236.34,
    y2: 62.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 263.63,
    y1: 3.5,
    x2: 263.63,
    y2: 18.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 271.34,
    y1: 11.21,
    x2: 255.92,
    y2: 11.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 95.62,
    y1: 248.72,
    x2: 95.62,
    y2: 264.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 103.33,
    y1: 256.44,
    x2: 87.91,
    y2: 256.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 32.18,
    y1: 247.94,
    x2: 32.18,
    y2: 264.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 40.67,
    y1: 256.44,
    x2: 23.69,
    y2: 256.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 62.52,
    y1: 214.99,
    x2: 62.52,
    y2: 240.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 75.33,
    y1: 227.8,
    x2: 49.71,
    y2: 227.8
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.3cd9629cac8da04136dcdd631174bcd9.svg";
export { ForwardRef as ReactComponent };